import { render, staticRenderFns } from "./ChequeTemplate.vue?vue&type=template&id=35f61c34&scoped=true"
import script from "./ChequeTemplate.vue?vue&type=script&lang=js"
export * from "./ChequeTemplate.vue?vue&type=script&lang=js"
import style0 from "./ChequeTemplate.vue?vue&type=style&index=0&id=35f61c34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f61c34",
  null
  
)

export default component.exports